import { render, staticRenderFns } from "./WrapperComponent.vue?vue&type=template&id=37e250da"
import script from "./WrapperComponent.vue?vue&type=script&lang=js"
export * from "./WrapperComponent.vue?vue&type=script&lang=js"
import style0 from "./WrapperComponent.vue?vue&type=style&index=0&id=37e250da&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e250da')) {
      api.createRecord('37e250da', component.options)
    } else {
      api.reload('37e250da', component.options)
    }
    module.hot.accept("./WrapperComponent.vue?vue&type=template&id=37e250da", function () {
      api.rerender('37e250da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WrapperComponent.vue"
export default component.exports